import { Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";

export default function TableLoader({ columns, rowsNum }) {
    return (
        <TableContainer sx={{ borderRadius: 6 }} component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        {columns.map((column, index) => (
                            <TableCell key={index} sx={{ width: column.width }} align={column.headerAlign || 'left'}>{column.headerName}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[...Array(rowsNum)].map((row, index) => (
                        <TableRow key={index}>
                            {columns.map((column, indexColumn) => (
                                <React.Fragment key={indexColumn}>
                                    {indexColumn === 0 ?
                                        <TableCell key={indexColumn} component="th" scope="row">
                                            <Skeleton animation="wave" variant="text" />
                                        </TableCell>
                                        :
                                        <TableCell key={indexColumn} >
                                            <Skeleton animation="wave" variant="text" />
                                        </TableCell>
                                    }
                                </React.Fragment>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
};